var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"gamePlayer",staticClass:"video-js vjs-fill",attrs:{"id":"game_player"}})}
var staticRenderFns = []

export { render, staticRenderFns }